module.exports = __webpack_public_path__ + "static/sepa_dark-bbbc737795e6896ac6064744e940822e.svg";